<script lang="ts">
  import type { ExternalEvalBenchmark } from './external-evals-catalog'

  import Icon from '$lib/components/Icon.svelte'

  interface Props {
    benchmark: ExternalEvalBenchmark
    selectedTaskCount: number
    onToggle: () => void
    onChooseTasks: () => void
  }

  let { benchmark, selectedTaskCount, onToggle, onChooseTasks }: Props = $props()

  const allTasksSelected = $derived(selectedTaskCount === benchmark.tasks.length)
</script>

<div
  class="flex min-h-36 flex-col gap-3 rounded-md border bg-surface-50 px-4 py-3 dark:bg-surface-800 {selectedTaskCount >
  0
    ? 'border-primary-600 ring-1 ring-inset ring-primary-600 dark:border-primary-500 dark:ring-primary-500'
    : 'border-surface-500 hover:border-primary-500 dark:border-surface-600'}"
>
  <label class="flex min-w-0 flex-1 cursor-pointer items-start gap-3">
    <input
      class="mt-1"
      type="checkbox"
      checked={allTasksSelected}
      indeterminate={selectedTaskCount > 0 && !allTasksSelected}
      aria-label={`Select all ${benchmark.title} tasks`}
      onchange={onToggle}
    />
    <span class="min-w-0">
      <span class="block font-medium">{benchmark.title}</span>
      <span class="mt-1 block text-xs text-surface-500 dark:text-surface-300">
        {benchmark.category}
      </span>
      <span class="mt-1 line-clamp-2 block text-xs text-surface-500 dark:text-surface-300">
        {benchmark.description}
      </span>
    </span>
  </label>
  {#if benchmark.tasks.length > 1}
    <button
      type="button"
      class="mt-auto inline-flex items-center gap-0.5 self-end rounded-sm text-xs font-medium text-surface-600 transition-colors hover:text-primary-600 hover:underline focus-visible:text-primary-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500 dark:text-surface-200 dark:hover:text-primary-300 dark:focus-visible:text-primary-300"
      aria-label={`Choose ${benchmark.title} tasks`}
      onclick={onChooseTasks}
    >
      {selectedTaskCount} of {benchmark.tasks.length} tasks
      <Icon icon="iconoir:nav-arrow-right" class="h-3.5 w-3.5" />
    </button>
  {:else}
    <span class="mt-auto self-end text-xs text-surface-500 dark:text-surface-300">
      {benchmark.tasks[0].sampleCount?.toLocaleString() ?? 'Unknown number of'} samples
    </span>
  {/if}
</div>
